










// @ is an alias to /src
import { Vue, Component } from "vue-property-decorator";
import revolvaModel from "@/components/revolva.model.vue";
import revolvaToolBar from "@/components/revolva.toolBar.vue";
import RevolvaService from "@/service/revolva.service";
import * as actions from "@/service/revolva.action";
import Fullscreen from "vue-fullscreen";
Vue.use(Fullscreen, { name: "fs" });

interface FullscreenComponent extends Element {
  getState(): boolean;
  toggle(): void;
}

@Component({
  components: {
    revolvaModel,
    revolvaToolBar
  },
})
export default class App extends Vue {
  public root = document.documentElement;

  public productId = Number(
    this.$route.params.id === undefined ? 3 : this.$route.params.id
  );
  public revolva = new RevolvaService(this.productId);

  public fullScreenToggle() {
    (this.$refs.fullscreen as FullscreenComponent).toggle();
  }

  fullscreenChange(fullscreen: boolean) {
    actions.setCanvafullScreen(this.revolva, fullscreen);
    actions.onWindowResize(this.revolva);  
  }

  public updateRealViewportDimensions() {
   console.log(`1vh = ${window.innerHeight / 100}px`)
   this.root.style.setProperty('--real-vh', (window.innerHeight / 100) + "px");
 }

created() {

  this.updateRealViewportDimensions()

   window.addEventListener('resize', () => { 
     this.updateRealViewportDimensions()
  });
}
}
